import React, { useEffect, useState } from "react";
import _ from "lodash";

import AttributeInputField from "../../attributes/compare-table/attribute-input-field";
import AttributeErrors from "../../attributes/attribute-errors";

import AttributeGroupStore, { fetchAttributeGroup } from "../lib/attributeGroupStore";

import { findField } from "../../attributes/compare-table/field-builder";

const MeasuringAttributes = React.memo(({ refresh, groupId, isCompleted, showValidation, positionName, codingWipKey }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [definitions, setDefinitions] = useState([]);
    const groupData = AttributeGroupStore.useState((store) => store.groupData);

    useEffect(() => {
        fetchAttributeGroup(groupId, codingWipKey);
    }, [codingWipKey]);

    useEffect(() => {
        if (groupData && groupData[groupId]) {
            setDefinitions(groupData[groupId]);
            setIsLoading(false);
        }
    }, [groupData]);

    if (isLoading) {
        return <div>Loading ...</div>;
    }

    const attributes = definitions.map((attr) => {
        const Field = findField(attr.componentType);

        return (
            <div key={`measuringEdit_${attr.uuid}`}>
                <label>{attr.name}: </label>
                <AttributeInputField
                    id={`measuring_${attr.uuid}`}
                    name={`measuring_${attr.uuid}`}
                    Field={Field}
                    codingWipKey={codingWipKey}
                    attribute={{ ...attr }}
                    disabled={isCompleted}
                />
            </div>
        );
    });

    return (
        <div className="measuring-attributes" data-position={positionName}>
            {!_.isEmpty(definitions) && (
                <AttributeErrors
                    attributeGroups={[{ name: groupId, label: "", sortOrder: 1 }]}
                    attributesByGroup={{ [groupId]: definitions }}
                    readOnlyOverride={true}
                    showValidation={showValidation}
                />
            )}
            {attributes}
        </div>
    );
});

export default MeasuringAttributes;
